import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from './Modal';
import styles from './Dialog-tw-styles';

class Dialog extends PureComponent {
  render() {
    const {
      disableBackdropClick,
      disableEscapeKeyDown,
      onBackdropClick,
      onEscapeKeyDown,
      children,
      modalStyle,
      backdropStyle,
      onClose,
      open,
      role,
    } = this.props;
    
    const ariaLabelledby = this.props['aria-labelledby'];
    const ariaDescribedby = this.props['aria-describedby'];

    let backdropStyles = '';

    if (backdropStyle !== undefined) {
      backdropStyles = backdropStyle;
    } else {
      backdropStyles = styles.dialog.backdropStyle;
    }
    return (
      <div>
        {open && (
          <Modal
            disableBackdropClick={disableBackdropClick}
            disableEscapeKeyDown={disableEscapeKeyDown}
            onBackdropClick={onBackdropClick}
            onEscapeKeyDown={onEscapeKeyDown}
            onClose={onClose}
            modalStyle={modalStyle}
            backdropStyle={classNames(backdropStyles)}
            open={open}
            role={role}
            aria-labelledby={ariaLabelledby}
            aria-describedby={ariaDescribedby}
          >
            {children}
          </Modal>
        )}
      </div>
    );
  }
}

Dialog.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  modalStyle: PropTypes.string.isRequired,
  disableBackdropClick: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  onEscapeKeyDown: PropTypes.func,
  backdropStyle: PropTypes.string,
  role: PropTypes.string,
  'aria-labelledby': PropTypes.string,
  'aria-describedby': PropTypes.string,
};

Dialog.defaultProps = {
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  onClose: () => null,
  onBackdropClick: () => null,
  onEscapeKeyDown: () => null,
  backdropStyle: styles.dialog.backdropStyle,
  role: 'dialog',
};

export default Dialog;
